import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { BehaviorSubject, debounceTime, filter, Subject } from 'rxjs'
import { JobSearchService } from './job-search.service'
import { IJobSearch } from './job-search.interface'
import { ActivatedRoute, NavigationStart, Router } from '@angular/router'
import { TokenService } from '../../../../services/token.service'

@Component({
  selector: 'm-menu-horizontal',
  templateUrl: './menu-horizontal.component.html',
  styleUrls: ['./menu-horizontal.scss'],
})
export class MenuHorizontalComponent implements OnInit {
  public form = new FormGroup({})
  public jobSearchControl = new FormControl('')
  public filteredJobs = new BehaviorSubject<IJobSearch[]>([])
  public isVendor = false
  public searching$ = new Subject<boolean>()
  private jobs: IJobSearch[] = []

  constructor(
    private _jobSearchService: JobSearchService,
    private _router: Router,
    private _cd: ChangeDetectorRef,
    private _tokenService: TokenService
  ) {}

  ngOnInit() {
    this.form.addControl('job_number', this.jobSearchControl)
    this.isVendor = this.isVendorUser()

    this._router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        if (
          event instanceof NavigationStart &&
          event.url === '/showroom/dashboard'
        ) {
          this.isVendor = this.isVendorUser()
        }
      })

    this.jobSearchControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((value) => {
        if (value && value.length > 4) {
          this.searching$.next(true)
          this._jobSearchService.searchJobs(value).subscribe((res: any[]) => {
            this.filteredJobs.next(res)
            this.jobs = res
            this._cd.detectChanges()
            this.searching$.next(false)
          })
        } else {
          this.filteredJobs.next([])
          this.jobs = []
          this.searching$.next(false)
          this._cd.detectChanges()
        }
      })
  }

  getMatchingJob() {
    return this.jobs.find(
      (job) => job.version_job_number == this.jobSearchControl.value
    )
  }

  openJob() {
    const job = this.getMatchingJob()
    if (job) {
      this.onJobSelect(job)
    } else {
      alert('No matching job found')
    }
  }

  public isVendorUser(): boolean {
    const roles = this._tokenService.getRoles()
    return roles.includes('vendor_user') || roles.includes('vendor_admin')
  }

  public getJobDisplay(job: IJobSearch) {
    let str = `${job.version_job_number} ${job.showroom_name}`

    if (job.material_name) {
      str += ` ${job.material_name}`
    }

    if (job.finish_name) {
      str += `/${job.finish_name}`
    }

    const totalItemCount =
      job.version_parts_count +
      job.version_footage_items_count +
      job.custom_items_count

    str += `(${totalItemCount})`

    return str
  }

  public onJobSelect(job: IJobSearch) {
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate([
        '/vendor/projects',
        job.proposal_id,
        'order',
        job.order_id,
      ])
    })

    this.jobSearchControl.setValue('')
    this.filteredJobs.next([])
  }
}
